<template>
  <div :style="{ zoom: zoomRatio }">
    <div :id="`pumpDailyGraph_bar_${id}`" :style="{ width: w + 'px', height: h + 'px'}">
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import dayjs from 'dayjs'
import { derrorFactory, errorFactory, dlogFactory } from '@u/log'
import { qcopy, findObjIndexInArray } from '@u'
import $ from 'jquery'
import { _getPumpBasalFromRecords, _getPumpBasalShouldShowLabelRecordsFromBasals, _getPumpBigDosageFromRecords, _getMergedPumpBigDosageFromRecords } from '@u/reportHelper'
import { _basalRateBaseSettingInfosFromValueArray, labelSize } from '@u/reportHelperPump'
import { _transferBasalData } from '@u/reportHelperPump'
import { _axisLabelColor, _axisLineColor } from '@u/reportUiVariables-pump'
const error = errorFactory('chartPumpBasal', false)
const derror = derrorFactory('chartPumpBasal', true)
const log = dlogFactory('chartPumpBasal', true)
// window.dayjs = dayjs

let _id = 1
const fmt = 'YYYY-MM-DD HH:mm:ss'

export default {
  name: 'CChartPumpBasal',
  mixins: [reDrawTrigger],
  props: {
    value: {
      type: [Object],
      default: () => {}
    }
  },
  data() {
    _id++
    const id = `cchartpumpbasal_${+new Date()}_${_id}`
    return {
      id,
      isFirst: false,
      isLast: false
    }
  },
  beforeDestroy() {
  },
  computed: {
    w() {
      const ds = this.ds
      return Math.round(ds * (1600 / 1740))
    },
    h() {
      const ds = this.ds
      let h = ds * (414 / 1240)
      
      const grid = this.getCommonGridOpt()
      
      if (grid.bottom && !Number.isNaN(+grid.bottom)) {
        h -= grid.bottom
      }
      
      if (grid.top && !Number.isNaN(+grid.top)) {
        h -= grid.top
      }
      
      return h
    }
  },
  mounted() {
    this.render(false)
  },
  methods: {
    getBasalSeries() { // 获取基础率的矩形表格效果图
      const { value = {}, lfs, basalRateInfoMsg } = this
      const { valueArray: valueArrayStr } = value
      const tmp = _basalRateBaseSettingInfosFromValueArray(valueArrayStr, '[ChartPumpBasal/getBasalSeries]')
      const startOfToday = dayjs().startOf('day')
      const _basals = []
      
      const l = tmp.length
      if (!l) {
        derror(`压入一个占位数据，否则整个表格一片白`)
        _basals.push([+startOfToday.add(1, 'day').subtract(20, 'minute'), 1.2, undefined, true])
        // _basals.push([+startOfToday.add(1, 'day').subtract(60 * 10, 'minute'), 0.2, undefined, true])
      }
      tmp.forEach((gap, i) => {
        const isLast = l - i <= 1
        const { start, end, value } = gap
        const $start = startOfToday.add(start, 'hour')
        const $end = startOfToday.add(end, 'hour')
        
        _basals.push([+$start, value])
        
        if (isLast) {
          _basals.push([+$end, value])
        }
      })
      const _showLabelBasals = _getPumpBasalShouldShowLabelRecordsFromBasals(_basals)
      const basals = _basals.map(v => {
        const [v1, v2, ...rest] = v || []
        return [
          v1,
          _transferBasalData(v2),
          ...rest,
          `orin-${v2}`
        ]
      })

      const basalsLabels = []
      _basals.forEach((v, i) => {
        const [v1, v2, ...rest] = v || []
        const next = _basals[i + 1]
        if (next) {
          // 有下一个，那么得到下一个时间点，从而得到label的时间点
          const middleTime = Math.floor((next[0] - v1) / 2) + +v1
          basalsLabels.push([
            middleTime,
            _transferBasalData(v2),
            ...rest,
            `orin-${v2}`
          ])
        }
      })
      
      const arr = [] // 结果series
      
      const rst = { // 矩形输注图;基础率
        z: -1,
        name: 'area-line',
        type: 'line',
        step: 'end',
        label: { // tbc:label得换成新的series去计算，否则无非做到放到矩形的正中间
          show: false,
          fontSize: labelSize,
          // position: 'top'
          position: 'top',
          align: 'center',
          verticalAlign: 'bottom',
          distance: (8 / 12) * lfs,
          // offset: [0, 0],
          formatter: (params = {}) => {
            const { data = [] } = params
            const value = data[1]
            const timePoint = data[0]
            const isPlaceholder = !!data[3]
            if (isPlaceholder) {
              return ''
            }
            // step1, 判断是否能显示label
            const shoudShowI = findObjIndexInArray(_showLabelBasals, data.slice(), (arrv, compareToMeArr) => {
              let same = false
              same = arrv && compareToMeArr && +arrv[0] === +compareToMeArr[0] // 时间点对上
              return same
            })
            const shouldShow = shoudShowI >= 0
            if (!shouldShow) {
              return ''
            }

            const l = data.length
            const last = data[l - 1]
            let orinV = ''
            if (/orin-(.+)/.test(last)) {
              orinV = RegExp.$1
            }
            if (value) { // 有值
              return orinV !== '' ? `${orinV}` : `${value}`
            } else { // 为0，不显示label
              return ''
            }
          },
          color: this.basalC
        },
        lineStyle: {
          show: true,
          width: 3,
          // color: '#00BAFF'
          color: this.basalBorderC
        },
        areaStyle: {
          emphasis: {
            disabled: true
          }, // 禁用停留高亮
          opacity: 0.2,
          color: this.basalC
        },
        symbolSize: 0,
        data: basals
      }
      
      arr.push(rst)

      const rst2 = { // 矩形输注图，专门用来显示label到中间
        z: -1,
        name: 'area-line',
        type: 'line',
        label: { // tbc:label得换成新的series去计算，否则无非做到放到矩形的正中间
          show: true,
          fontSize: labelSize,
          position: 'top',
          align: 'center',
          verticalAlign: 'bottom',
          distance: (8 / 12) * lfs,
          // offset: [0, 0],
          formatter: (params = {}) => {
            const { data = [] } = params
            const value = data[1]
            const timePoint = data[0]
            const isPlaceholder = !!data[3]
            if (isPlaceholder) {
              return ''
            }
            
            const l = data.length
            const last = data[l - 1]
            let orinV = ''
            if (/orin-(.+)/.test(last)) {
              orinV = RegExp.$1
            }
            if (value) { // 有值
              return orinV !== '' ? `${orinV}` : `${value}`
            } else { // 为0，不显示label
              return ''
            }
          },
          color: this.basalC
        },
        lineStyle: {
          show: false,
          width: 0,
          // color: '#00BAFF'
          color: this.basalC
        },
        symbolSize: 0,
        data: basalsLabels
      }
      arr.push(rst2)
      
      return arr
      
      function _sameObj(v, compareToMeObj) {
        let same = false
        if (v && compareToMeObj) {
          same = v[0] && compareToMeObj[0] && +v[0] === +compareToMeObj[0]
        }
        return same
      }
    },
    pumpSeriesFromDataSource(what) {
      const { cmax, cmaxC, cmin, cminC, normalC, stripeBgC, stripeInnerBorderC, lfw, lfs, largerRatio, unit, ds, value } = this
      
      const series = [
        ...this.getBasalSeries()        
      ]
      
      return series
    },
    getGrid(what = 'top', orin = {}) {
      const { isFirst, lfs, isLast } = this
      const rst = orin
      
      if (what === 'top') {
        rst.bottom = 0
      }
      
      if (what === 'middle') {
        rst.top = 0
        rst.bottom = 0
      }
      
      if (what === 'bottom') {
        rst.bottom = lfs * 2
        rst.top = 0
      }
      
      return rst
    },
    getCommonXAxis(date) {
      const { isFirst, lfs } = this
      const $start = date ? dayjs(date) : dayjs().startOf('day')
      const $end = $start.add(1, 'day').startOf('day')
      return [
        {
          boundaryGap: false,
          type: 'time',
          splitLine: {
            show: false
          },
          min: +$start,
          max: +$end,
          splitNumber: 24,
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: _axisLineColor
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: _axisLabelColor,
            }
          },
          axisLabel: {
            show: true,
            showMaxLabel: true,
            color: _axisLabelColor,
            fontWeight: 800,
            fontSize: (18 / 12) * lfs,
            formatter: (v, i) => {
              const rst = dayjs(v).format('HH:mm')
              if ((i - 1) % 3 === 0) {
                if (i > 1 && `${rst}` === '00:00') {
                  return '24:00'
                }
                return rst
              } else {
                return ''
              }
            }
          }
        }
      ]
    },
    getCommonGridOpt() {
      const { lfs, ds } = this
      const uiW = 1754
      const oneHourW = 45.35 / uiW * ds
      const grid = {
        left: (64 / 12) * lfs,
        bottom: lfs * 2,
        // top: ((34 + 2) / 12) * lfs
        top: (((34 + 2) / 12) + 2) * lfs
      }
      grid.right = oneHourW * (45 / 47.19)
      
      return grid
    },
    refreshTriggered() {
      derror(`refreshTriggered`)
      this.render(true)
    },
    render(isUpdate = false) {
      if (!isUpdate) {
        this.initChart()
      } else {
        this.updateChart()
      }
    },
    getOpt(what) {
      const { value, cmax, cmaxC, cmin, cminC, lfw, lfs, unit, isFirst } = this
      const { date } = value
      
      const labelCom = {
        fontSize: lfs - 2,
        padding: [1, 1, 1, 1],
        borderRadius: [2, 2, 2, 2]
      }
      
      const grid = this.getCommonGridOpt()
      
      const series = (this.pumpSeriesFromDataSource(what))
      const xAxis = this.getCommonXAxis()
      
      const option = {
        animation: false,
        grid,
        xAxis,
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 5.5,
            splitNumber: 11, // showMaxLabel设置成false，那么只会显示到10;因为maxLabel会显示不全，所以我们这边设置最大成11
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: isFirst ? {
                color: _axisLineColor
              } : {
                width: 1,
                color: _axisLineColor
              }
            },
            axisLabel: {
              show: true,
              showMaxLabel: false,
              color: _axisLabelColor,
              fontWeight: 500,
              fontSize: (16 / 12) * lfs,
              formatter: (value, index) => { // 改变这里逻辑，要对应改变_transferBasalData
                const shouldShowVs = [0, 2.5, 5] // 这是坐标值已有的值
                const shouldShowTxts = [0, 2.5, `5U/h`] // _transferBigDosageBarData(shouldShowTxts[i]) == shouldShowVs[i]
                const i = shouldShowVs.indexOf(+value)
                return i >= 0 ? shouldShowTxts[i] : ''
              }
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          },
          {
            type: 'value',
            min: 0,
            max: 6,
            splitNumber: 3, // showMaxLabel设置成false，那么只会显示到10;因为maxLabel会显示不全，所以我们这边设置最大成11
            minorTick: {
              show: false
            },
            splitLine: {
              show: true
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false,
              showMaxLabel: false
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          },
          {
            type: 'value',
            min: 0,
            max: 6,
            position: 'right',
            splitNumber: 3, // showMaxLabel设置成false，那么只会显示到10;因为maxLabel会显示不全，所以我们这边设置最大成11
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: _axisLineColor
              }
            },
            axisLabel: {
              show: false,
              showMaxLabel: false
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          }
        ],
        series
      }
      derror(`getOpt[${what}], option`, option)
      // derror(JSON.stringify(option))
      return option
    },
    initChart() {
      const { id } = this
      const canvasid = `pumpDailyGraph_bar_${id}`
      try {
        const myChart = this.$echarts.init(document.getElementById(`${canvasid}`), null, { renderer: 'svg' })
        const opt = this.getOpt('initChart')
        
        myChart.setOption(opt)
        
        this._myCharts = [myChart]
      } catch (error) {
        console.error('被捕获:' + error)
      }
    },
    updateChart() {
      const myChart = this._myCharts[0]
      const newOpt = this.getOpt('updateChart')
      
      this.$nextTick(() => {
        try {
          if (myChart) {
            myChart.setOption(newOpt)            
          }
        } catch (error) {
          console.error('被捕获:' + error)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
